import styled from '@emotion/styled';

export const StyledEditorHeader = styled('div')({
  padding: '12px 32px',
});

export const StyledEditorHeaderRow = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 16,
  justifyContent: 'space-between',
});

export const StyledEditorHeaderSide = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 16,
});

export const StyledEditorHeaderActions = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 12,
});
